import { CorrectionForm } from './correction';
import { FormProps } from './types';
import { MovingForm } from './moving';

export const SelectTxTypeDialog = ({ dialog, onCancel, onSubmit }: { 
  dialog: 'correction' | 'moving' | 'none',
 } & Omit<FormProps, 'open'>) => {


  if (dialog === 'correction')  {return <CorrectionForm open={true} onCancel={onCancel} onSubmit={onSubmit} />;}
  if (dialog === 'moving')  {return <MovingForm open={true} onCancel={onCancel} onSubmit={onSubmit} />;}

  return null;
};